import { Box, Link, Stack, Container, Typography } from "@mui/material";
import { ISellerData } from "src/Contexts/LandingPageContext/LandingPagesTypes";
import { formatString } from "@format-string/core";

interface NavbarProps {
  sellerData: ISellerData;
}

export const Footer = ({ sellerData }: NavbarProps) => {
  return (
    <Box
      component="footer"
      sx={{
        py: 4,
        px: 2,
        mt: "auto",
        backgroundColor: "#111827",
        color: "#D1D5DB",
        borderTop: (theme) => `1px solid ${theme.palette.divider}`,
      }}
    >
      <Container maxWidth="lg">
        <Stack
          direction={{ xs: "column", sm: "row" }}
          spacing={{ xs: 1, sm: 3 }}
          justifyContent="center"
          alignItems="center"
          mb={3}
        >
          <Link href="#" color="inherit" underline="hover">
            Política de Privacidade
          </Link>
          <Link href="#" color="inherit" underline="hover">
            Termos de Uso
          </Link>
          <Typography variant="body2">
            Contato:{" "}
            {formatString({
              value: sellerData?.phone1 || "",
              type: "phone",
            })}
          </Typography>
          <Typography variant="body2">
            Email: {sellerData?.email || ""}
          </Typography>
        </Stack>

        <Typography variant="body2" align="center">
          {"© "}
          {new Date().getFullYear()}{" "}
          <Link color="inherit" href="#" underline="hover">
            {sellerData?.name || ""}
          </Link>{" "}
          Todos os direitos reservados.
        </Typography>
      </Container>
    </Box>
  );
};
